import React from 'react';
import Plot from 'react-plotly.js';

const Plot3D = ({ data, title = '3D Surface Plot' }) => {
  console.log('🎨 Plot3D component received data:', data);
  console.log('🎨 Data keys:', Object.keys(data || {}));
  console.log('🎨 x length:', data?.x?.length);
  console.log('🎨 y length:', data?.y?.length);
  console.log('🎨 z structure:', Array.isArray(data?.z) ? 'Array' : typeof data?.z);
  
  if (!data || !data.x || !data.y || !data.z) {
    console.log('❌ Plot3D: Missing required data fields');
    return <div className="plot-error">Invalid 3D plot data</div>;
  }

  // Reshape flat z array into 2D matrix for Plotly
  const reshapeZ = (flatZ, xLen, yLen) => {
    const matrix = [];
    for (let i = 0; i < xLen; i++) {
      matrix[i] = [];
      for (let j = 0; j < yLen; j++) {
        matrix[i][j] = flatZ[i * yLen + j];
      }
    }
    return matrix;
  };

  const zMatrix = Array.isArray(data.z[0]) ? data.z : reshapeZ(data.z, data.x.length, data.y.length);
  console.log('🎨 Reshaped z matrix dimensions:', zMatrix.length, 'x', zMatrix[0]?.length);

  const plotData = [{
    x: data.x,
    y: data.y,
    z: zMatrix,
    type: 'surface',
    colorscale: 'Viridis',
    showscale: true,
    name: data.function_name || 'f(x,y)'
  }];

  const layout = {
    title: {
      text: title,
      font: { size: 16, family: 'Arial, sans-serif' }
    },
    scene: {
      xaxis: {
        title: data.variables?.[0] || 'x',
        gridcolor: '#e5e7eb'
      },
      yaxis: {
        title: data.variables?.[1] || 'y',
        gridcolor: '#e5e7eb'
      },
      zaxis: {
        title: data.function_name || 'f(x,y)',
        gridcolor: '#e5e7eb'
      },
      bgcolor: '#ffffff'
    },
    paper_bgcolor: '#ffffff',
    margin: { l: 0, r: 0, t: 60, b: 0 }
  };

  const config = {
    displayModeBar: true,
    displaylogo: false,
    modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d'],
    responsive: true
  };

  return (
    <div className="plot-container" style={{ width: '100%', height: '500px' }}>
      <Plot
        data={plotData}
        layout={layout}
        config={config}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default Plot3D;